module.exports = __webpack_public_path__ + "static/media/jose.c1a1a7dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/testimonials/jose.png
// module id = 1436
// module chunks = 0